import React, { useRef, useState } from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

const UserChooser = ({ users, onSelect }) => {
    const [selected, setSelected] = useState(undefined);
    const [query, setQuery] = useState(/\w+/);
    const searchRef = useRef('');

    const handleClick = user => {
        onSelect(user);
        setSelected(user.id);
    }

    const handleSearchChange = () => {
        const { value = '' } = searchRef.current || {};
        setQuery(Boolean(value) ? new RegExp(value, 'i') : /\w+/);
    }

    return (
        <Grid container direction="column" spacing={1}>
            <Grid item xs={12} md={4}>
                <TextField
                    id="search"
                    label="Search Referrers"
                    inputRef={searchRef}
                    onChange={handleSearchChange}
                    fullWidth
                    helperText="Type the name, email address, or phone number"
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <List >
                    {users?.filter(user => query.test(JSON.stringify(user)))
                        .slice(0, 25)
                        .map(user => {
                            const { id, name = '', email = '' } = user;
                            return (
                                <ListItem
                                    onClick={() => handleClick(user)}
                                    button
                                    key={id}
                                    selected={id === selected}
                                    disableGutters
                                >
                                    <ListItemText primary={name} secondary={email} />
                                </ListItem>
                            );
                        })}
                </List>
            </Grid>
        </Grid>

    );
};

export default UserChooser;